module.exports = __webpack_public_path__ + "img/cover_photo.9d6d1e9e.jpg";